import { LocaleFormat } from '@components'

import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../../enums/queryKeys'
import { getCurrentLocale } from '../../../../utils'
import { fetchBookkeepingCategories } from '../query-api'

interface UseBookkeepingCategoriesBookySearchProps {
  categoryIds?: number[]
  locale: LocaleFormat
  isEnabled?: boolean
}

export const useBookkeepingCategories = ({
  categoryIds,
  locale = getCurrentLocale(),
  isEnabled = true,
}: UseBookkeepingCategoriesBookySearchProps) => {
  const { organization } = useUserOrganization()

  const queryParams = {
    locale,
    categoryIds,
    organizationId: organization?.id,
  }

  const { data, isLoading } = useQuery(
    [QueryKeys.DebugBookkeepingCategories, queryParams],
    () => fetchBookkeepingCategories(queryParams),
    {
      enabled: isEnabled,
      cacheTime: 0,
      keepPreviousData: false,
      retry: 1,
    },
  )

  return {
    suggestedCategories: data?.categories || [],
    isLoading,
  }
}
